import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  class: "input-group-prepend"
}
const _hoisted_5 = { class: "input-group-text" }
const _hoisted_6 = {
  key: 1,
  class: "input-group-append"
}
const _hoisted_7 = { class: "input-group-text" }
const _hoisted_8 = { key: 0 }

import { useField, Field } from "vee-validate";
import { SelectContext } from "element-plus";
import { computed, onMounted, ref, useSlots, watch } from "vue";
import { Options } from "@/types/components";
import axios, { AxiosRequestConfig } from "axios";
import { env } from "@/config";
// axios client
export type SelectProps = {
	label?: string;
	labelClasses?: string;
	required?: boolean;
	errorMessage?: string;
	hasIcon?: boolean;
	alternative?: boolean;
	inputGroupClasses?: { [k: string]: string } | string;
	class?: string;
	inputClasses?: { [k: string]: string } | string;
	group?: string;
	addonLeftIcon?: string;
	addonRightIcon?: string;
	name: string;
	placeholder: string;
	disabled?: boolean;
	value?: unknown;
	options?: Options<any>[];
	formGroupClasses?: { [k: string]: string } | string;
	fetch?: string;
	fetchConfig?: AxiosRequestConfig<any>;
	remote?: string;
	query_param?: string;
	url_param?: string;
	loading?: boolean;
	parent?: string | object | null | undefined;
	select?: (e: any) => void;
	params?: { [k: string]: string | number };
	selectOptions: Pick<SelectContext, "props">["props"] & {
		size?: "large" | "default" | "small";
		valueKey: string;
		returnAll?: boolean;
		labelKey: string;
		noDataText?: string;
		multiple: boolean;
	};
	size?: "sm" | "md" | "lg";
	inputHidden?: boolean;
	hidden?: boolean;
	smallLabel?: boolean;
	localSearch?: boolean;
};
// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    labelClasses: null,
    required: { type: Boolean },
    errorMessage: null,
    hasIcon: { type: Boolean },
    alternative: { type: Boolean },
    inputGroupClasses: null,
    class: null,
    inputClasses: null,
    group: null,
    addonLeftIcon: null,
    addonRightIcon: null,
    name: null,
    placeholder: null,
    disabled: { type: Boolean },
    value: null,
    options: null,
    formGroupClasses: null,
    fetch: null,
    fetchConfig: null,
    remote: null,
    query_param: null,
    url_param: null,
    loading: { type: Boolean },
    parent: null,
    select: null,
    params: null,
    selectOptions: null,
    size: null,
    inputHidden: { type: Boolean },
    hidden: { type: Boolean },
    smallLabel: { type: Boolean },
    localSearch: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	label?: string;
	labelClasses?: string;
	required?: boolean;
	errorMessage?: string;
	hasIcon?: boolean;
	alternative?: boolean;
	inputGroupClasses?: { [k: string]: string } | string;
	class?: string;
	inputClasses?: { [k: string]: string } | string;
	group?: string;
	addonLeftIcon?: string;
	addonRightIcon?: string;
	name: string;
	placeholder: string;
	disabled?: boolean;
	value?: unknown;
	options?: Options<any>[];
	formGroupClasses?: { [k: string]: string } | string;
	fetch?: string;
	fetchConfig?: AxiosRequestConfig<any>;
	remote?: string;
	query_param?: string;
	url_param?: string;
	loading?: boolean;
	parent?: string | object | null | undefined;
	select?: (e: any) => void;
	params?: { [k: string]: string | number };
	selectOptions: Pick<SelectContext, "props">["props"] & {
		size?: "large" | "default" | "small";
		valueKey: string;
		returnAll?: boolean;
		labelKey: string;
		noDataText?: string;
		multiple: boolean;
	};
	size?: "sm" | "md" | "lg";
	inputHidden?: boolean;
	hidden?: boolean;
	smallLabel?: boolean;
	localSearch?: boolean;
}



// State data
const focused = ref(false);
const model = ref<any>();
const modelHidden = ref<any>();
const options = ref<Options[]>(
	props?.options?.map(item => ({
		value: item,
		label: item.label,
	})) ?? []
);
const filteredOptions = ref<Options[]>([]);
const loading = ref(false);

// hooks
const { errorMessage, handleChange, value } = useField(props.name, undefined, {
	initialValue: props.value,
});
const slots = useSlots();

const getOptions = (query = "", value?: any) => {
	loading.value = true;

	if(options.value.length && query && props.localSearch)
		filteredOptions.value = options.value.filter((o: Options) => {
			return o.label
				? o.label.trim().toLowerCase().includes(query.trim().toLowerCase())
				: false
		})
	else if ((!props.remote || !props.query_param) && props.fetch) {
		if (props.parent === undefined || props.parent) {
			const url = props.parent
				? `/${props.fetch}/${
						typeof props.parent === "string"
							? props.parent
							: (props.parent as any).value
				  }`
				: `/${props.fetch}`;
			axios
				.get<{ data: any[] }>(`${env.OmniUrl}${url}`, props.fetchConfig)
				.then(res => {
					options.value = res.data.data.map(item => ({
						value: item,
						label: item[props.selectOptions.labelKey ?? "label"],
					}));
					if (props.parent === undefined || props.parent)
						filteredOptions.value = options.value;
				})
				.finally(() => {
					loading.value = false;
				});
		} else {
			loading.value = false;
		}
		return;
	} else if (props.remote && props.query_param)
		axios
			.get<any[]>(props.remote, {
				params: {
					[props.query_param]: query,
					...props.params,
				},
			})
			.then(res => {
				options.value = res.data.map(item => ({
					value: item,
					label: item[props.selectOptions.labelKey ?? "label"],
				}));
				filteredOptions.value = options.value;
			})
			.finally(() => (loading.value = false));
	else if (props.remote && props.url_param) {
		if(props?.params && props?.params[props.url_param] && !query)
			axios
				.get<any[]>(`${props.remote}/${props.params[props.url_param]}`)
				.then(res => {
					options.value = res.data.map(item => ({
						value: item,
						label: item[props.selectOptions.labelKey ?? "label"],
					}));
					filteredOptions.value = options.value;
				})
				.finally(() => (loading.value = false));
	} else if (props.options && props.parent === undefined) {
		filteredOptions.value = options.value;
		loading.value = false;
	}
	if (value) model.value = value;
	loading.value = false;
};
const fetchIndividual = (value: string | number) => {
	if (!props.remote || !props.query_param) return;
	loading.value = true;
	axios
		.get<any[]>(props.remote, {
			params: {
				[props.query_param]: value,
			},
		})
		.then(res => {
			options.value = res.data.map(item => ({
				value: item,
				label: item[props.selectOptions.labelKey ?? "label"],
			}));
			filteredOptions.value = options.value;
		})
		.finally(() => {
			loading.value = false;
			model.value = options.value[0].value;
			change(model.value);
		});
};

const hasIcon = computed(() => {
	const { addonRight, addonLeft } = slots;
	return (
		addonRight !== undefined ||
		addonLeft !== undefined ||
		props.addonRightIcon !== undefined ||
		props.addonLeftIcon !== undefined ||
		props.group
	);
});
const change = (a: any) => {
	if (props.select) props.select(a);
	return handleChange(a);
};

watch(
	() => props.value,
	() => {
		model.value = props.value;
		handleChange(props.value);
	}
);

watch(
	() => props.hidden,
	hide => {
		if (hide) model.value = value.value;
	}
);

watch(
	() => props.parent,
	() => {
		if (props.parent === null) filteredOptions.value = [];
		else if (props.parent === undefined) filteredOptions.value = options.value;
		else if (!props.fetch && !props.remote && props.parent) {
			model.value = undefined;
			handleChange(undefined);
			filteredOptions.value = options.value.filter(o =>
				typeof props.parent === "string"
					? o.parent === props.parent	
					: Array.isArray(o.value.parent)
						? o.value.parent.includes((props.parent as any)?.value)
						: o.value.parent === (props.parent as any)?.value
			);
			if (
				props.value &&
				filteredOptions.value.find(o =>
					typeof o.value === "string"
						? o.value === props.value
						: o.value.value === (props.value as any)?.value
				)
			) {
				model.value = props.value;
				handleChange(props.value);
			}
		} else {
			if (props.value) model.value = props.value;
			handleChange(props.value ?? undefined);
			getOptions();
		}
	}
);

watch(
	() => model.value,
	() => {
		modelHidden.value = filteredOptions.value.find(
			o => o.value.value === model.value
		)?.label;
	}
);

watch(
	() => value.value,
	(newVal, oldVal) => {
		if (newVal === undefined && oldVal !== undefined) {
			model.value = undefined;
		}
	}
);

watch(
	() => props.params,
	(newValue, prevValue) => {
		const paramKey = props.url_param
			? props.url_param
			: props.query_param
		if (
			newValue?.[paramKey ?? ""] !=
			prevValue?.[paramKey ?? ""]
		)
			getOptions();
	}
);

onMounted(() => {
	if (
		(typeof props.value === "string" || typeof props.value === "number") &&
		props.remote
	)
		fetchIndividual(props.value);
	else getOptions("", props.value);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (!__props.hidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["form-group", __props.formGroupClasses])
      }, [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          (__props.label)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                class: _normalizeClass(["text-muted form-control-label", __props.labelClasses])
              }, [
                (__props.smallLabel)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(__props.label), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.label), 1)),
                (__props.required)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([
				{
					'has-danger': !!_unref(errorMessage),
					'input-group': _unref(hasIcon),
					'input-group-alternative': __props.alternative,
					focused: focused.value,
					'has-label': __props.label || _ctx.$slots.label,
				},
				__props.inputGroupClasses,
			])
        }, [
          (__props.addonLeftIcon || _ctx.$slots.addonLeft)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "addonLeft", {}, () => [
                    _createElementVNode("i", {
                      class: _normalizeClass(__props.addonLeftIcon)
                    }, null, 2)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_select, {
            modelValue: model.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
            placeholder: __props.placeholder,
            name: __props.name,
            size: 
					__props.size === 'sm' ? 'small' : __props.size === 'lg' ? 'large' : __props.selectOptions.size
				,
            "value-key": __props.selectOptions.valueKey,
            class: "form-control",
            "no-data-text": __props.selectOptions.noDataText,
            loading: loading.value,
            filterable: "",
            remote: !!__props.remote,
            "remote-method": getOptions,
            "remote-show-suffix": true,
            multiple: __props.selectOptions.multiple,
            disabled: __props.disabled,
            onChange: change
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((filteredOptions.value as Options<any>[]), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: 
						props.remote ? item.value?.[__props.selectOptions.valueKey] : item.value
					,
                  label: 
						props.remote ? item.value?.[__props.selectOptions.labelKey] : item.label
					,
                  class: _normalizeClass(props.selectOptions.size),
                  value: 
						props.remote || __props.selectOptions.returnAll
							? item.value
							: item.value[__props.selectOptions.valueKey]
					
                }, null, 8, ["label", "class", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "name", "size", "value-key", "no-data-text", "loading", "remote", "multiple", "disabled"]),
          (__props.addonRightIcon || _ctx.$slots.addonRight)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "addonRight", {}, () => [
                    _createElementVNode("i", {
                      class: _normalizeClass(__props.addonRightIcon)
                    }, null, 2)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _renderSlot(_ctx.$slots, "infoBlock"),
        _renderSlot(_ctx.$slots, "helpBlock", {}, () => [
          _withDirectives(_createElementVNode("small", {
            class: _normalizeClass(["text-danger invalid-feedback", { 'mt-2': _unref(hasIcon) }]),
            style: {"display":"block"}
          }, _toDisplayString(_unref(errorMessage)), 3), [
            [_vShow, _unref(errorMessage)]
          ])
        ]),
        (props.inputHidden)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(Field), {
                id: `hidden/${__props.name}`,
                name: `hidden/${__props.name}`,
                modelValue: modelHidden.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelHidden).value = $event)),
                type: "hidden"
              }, null, 8, ["id", "name", "modelValue"])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})